/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'angular2-image-zoom/src/image-zoom-container.component';
const styles_ImageZoomContainer:any[] = ['[_nghost-%COMP%] {\n            position: absolute;\n            text-align: center;\n            overflow: hidden;\n            z-index: 100;\n            float: left;\n            background: rgb(255, 255, 255) no-repeat;\n            pointer-events: none;\n        }'];
export const RenderType_ImageZoomContainer:i0.RendererType2 = i0.ɵcrt({encapsulation:0,
    styles:styles_ImageZoomContainer,data:{}});
export function View_ImageZoomContainer_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
export function View_ImageZoomContainer_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'image-zoom-container',
      ([] as any[]),(null as any),[[(null as any),'mousemove'],[(null as any),'mouseleave'],
          [(null as any),'MozMousePixelScroll'],[(null as any),'DOMMouseScroll'],[(null as any),
              'mousewheel']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('mousemove' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onMousemove($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,1).onMouseleave($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('MozMousePixelScroll' === en)) {
          const pd_2:any = ((<any>i0.ɵnov(_v,1).onMouseScroll($event)) !== false);
          ad = (pd_2 && ad);
        }
        if (('DOMMouseScroll' === en)) {
          const pd_3:any = ((<any>i0.ɵnov(_v,1).onMouseScroll($event)) !== false);
          ad = (pd_3 && ad);
        }
        if (('mousewheel' === en)) {
          const pd_4:any = ((<any>i0.ɵnov(_v,1).onMouseScroll($event)) !== false);
          ad = (pd_4 && ad);
        }
        return ad;
      },View_ImageZoomContainer_0,RenderType_ImageZoomContainer)),i0.ɵdid(1,49152,
      (null as any),0,i1.ImageZoomContainer,[i0.ElementRef],(null as any),(null as any))],
      (null as any),(null as any));
}
export const ImageZoomContainerNgFactory:i0.ComponentFactory<i1.ImageZoomContainer> = i0.ɵccf('image-zoom-container',
    i1.ImageZoomContainer,View_ImageZoomContainer_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvQXN5bHVtL2lkZW50aXR5LXZhZ3JhbnQvc3JjL2FzeWx1bS1pZGVuZXRpdHkvbm9kZV9tb2R1bGVzL2FuZ3VsYXIyLWltYWdlLXpvb20vc3JjL2ltYWdlLXpvb20tY29udGFpbmVyLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9Vc2Vycy9Bc3lsdW0vaWRlbnRpdHktdmFncmFudC9zcmMvYXN5bHVtLWlkZW5ldGl0eS9ub2RlX21vZHVsZXMvYW5ndWxhcjItaW1hZ2Utem9vbS9zcmMvaW1hZ2Utem9vbS1jb250YWluZXIuY29tcG9uZW50LmQudHMiLCJuZzovLy9DOi9Vc2Vycy9Bc3lsdW0vaWRlbnRpdHktdmFncmFudC9zcmMvYXN5bHVtLWlkZW5ldGl0eS9ub2RlX21vZHVsZXMvYW5ndWxhcjItaW1hZ2Utem9vbS9zcmMvaW1hZ2Utem9vbS1jb250YWluZXIuY29tcG9uZW50LmQudHMuSW1hZ2Vab29tQ29udGFpbmVyX0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGltYWdlLXpvb20tY29udGFpbmVyPjwvaW1hZ2Utem9vbS1jb250YWluZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtVQUFBO2NBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtNQUFBLG1FQUFBO01BQUE7Ozs7In0=



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/aot/node_modules/angular2-image-zoom/src/image-zoom-container.component.ngfactory.ts